"use client";

import { Badge } from "@fm/ui";

export interface VehicleHighlightsProps {
  highlights: string[];
}

export function VehicleHighlights({ highlights }: VehicleHighlightsProps) {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-bold mb-4">Highlights</h3>
      <div className="flex flex-wrap gap-2">
        {highlights.map((highlight, index) => (
          <Badge
            key={index}
            variant="outline"
            className="rounded-full px-4 py-1 text-sm font-normal border-gray-200 text-foreground"
          >
            {highlight}
          </Badge>
        ))}
      </div>
    </div>
  );
}
